import { Box, Fade, Slide } from '@mui/material';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { useReviewBodyContext } from '../Context';
import { DesktopSidebarProduct } from './Desktop';
import { MobileSidebarProduct } from './Mobile';
import { SidebarProductCardImpressionWrapper } from './SidebarProductCardImpressionWrapper';
export function SidebarProductCard() {
  const {
    isSidebarVisible
  } = useReviewBodyContext();
  const {
    detailedReview,
    marketplaceEntity: {
      details: {
        isMonetizing,
        isActive
      }
    }
  } = useReviewContext();
  if (!detailedReview || !isMonetizing || !isActive) {
    return null;
  }
  return <Box sx={theme => ({
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: 0
    },
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      width: '100%',
      bottom: 0,
      left: 0,
      zIndex: 5
    }
  })}>
      <Slide direction="up" in={isSidebarVisible} mountOnEnter timeout={300}>
        <Box display={{
        xs: 'block',
        md: 'none'
      }} data-testid="review-sidebar-product-card-mobile-container">
          <SidebarProductCardImpressionWrapper>
            <MobileSidebarProduct />
          </SidebarProductCardImpressionWrapper>
        </Box>
      </Slide>
      <Fade in={isSidebarVisible} mountOnEnter timeout={150}>
        <Box display={{
        xs: 'none',
        md: 'flex'
      }} justifyContent="center" data-testid="review-sidebar-product-card-desktop-container">
          <SidebarProductCardImpressionWrapper>
            <DesktopSidebarProduct />
          </SidebarProductCardImpressionWrapper>
        </Box>
      </Fade>
    </Box>;
}
export default SidebarProductCard;